import { BzbsService } from '@bzbs/react-api-client';
import React, { createContext, useContext } from 'react';

export type BuzzebeesServiceContextType = {
  appId: string;
  appName: string;
  bzbsService: BzbsService;
  urls: {
    webCallback: string;
    cart: string;
  };
};

export const BuzzebeesServiceContext = createContext<BuzzebeesServiceContextType>({
  appId: '',
  appName: '',
  bzbsService: {} as BzbsService,
  urls: {
    webCallback: '',
    cart: '',
  },
});

export function useBuzzebeesServiceContext() {
  return useContext(BuzzebeesServiceContext);
}

export type BuzzebeesServiceProviderProps = {
  appId: string;
  appName: string;
  bzbsService: BzbsService;
  urls: {
    webCallback: string;
    cart: string;
  };
  children: React.ReactNode;
};

export function BuzzebeesServiceProvider({
  appId,
  appName,
  bzbsService,
  urls,
  children,
}: BuzzebeesServiceProviderProps) {
  return (
    <BuzzebeesServiceContext.Provider
      value={{
        appId,
        appName,
        urls,
        bzbsService,
      }}
    >
      {children}
    </BuzzebeesServiceContext.Provider>
  );
}
